import { CurrentOrderSite } from "@hydrologiq/gql-experience/graphql"
import Figure from "../generic/Figure"
import FigureContent from "../generic/FigureContent"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

function CustomerSiteFigure({ context, customerName }: { context?: CurrentOrderSite; customerName?: string }) {
  const siteLabel = context?.name ? (
    <FigureContent.Label fontSize="xs" truncate tooltip={context.name}>{context.name}</FigureContent.Label>
  ) : undefined

  return (
    <Figure heading="Customer site" compact={isCompactFigure("summary")}>
      <FigureContent.Root>
        <FigureContent.SubText link={siteLabel}>current</FigureContent.SubText>
        <FigureContent.Value fontSize={customerName ? "md" : undefined} truncate maxWidth="100%" tooltip={customerName}>
          {customerName || "No deployment"}
        </FigureContent.Value>
      </FigureContent.Root>
    </Figure>
  )
}

export default CustomerSiteFigure
